"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@aws-amplify/core");
var Amplify_UI_Theme_1 = require("../Amplify-UI/Amplify-UI-Theme");
var Amplify_UI_Components_React_1 = require("../Amplify-UI/Amplify-UI-Components-React");
var types_1 = require("./common/types");
var PhoneField_1 = require("./PhoneField");
var data_test_attributes_1 = require("../Amplify-UI/data-test-attributes");
var index_1 = require("./utils/index");
var labelMap = (_a = {},
    _a[types_1.UsernameAttributes.EMAIL] = 'Email',
    _a[types_1.UsernameAttributes.PHONE_NUMBER] = 'Mobile Number',
    _a[types_1.UsernameAttributes.USERNAME] = 'Username',
    _a);
var AuthPiece = /** @class */ (function (_super) {
    __extends(AuthPiece, _super);
    function AuthPiece(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            inputs: {},
            urlParams: {}
        };
        _this.inputs = {};
        _this._isHidden = true;
        _this._validAuthStates = [];
        _this.phone_number = '';
        _this.changeState = _this.changeState.bind(_this);
        _this.error = _this.error.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.renderUsernameField = _this.renderUsernameField.bind(_this);
        _this.getUsernameFromInput = _this.getUsernameFromInput.bind(_this);
        _this.onPhoneNumberChanged = _this.onPhoneNumberChanged.bind(_this);
        return _this;
    }
    AuthPiece.prototype.componentDidMount = function () {
        this.checkUrlForEmail();
    };
    AuthPiece.prototype.componentDidUpdate = function (prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.authState !== prevProps.authState) {
            this.checkUrlForEmail();
        }
    };
    AuthPiece.prototype.checkUrlForEmail = function () {
        var _a = this.props.usernameAttributes, usernameAttributes = _a === void 0 ? 'username' : _a;
        if (window.location.href) {
            var email = (index_1.getParameterByName('email'));
            if (email) {
                this.setState({ urlParams: __assign(__assign({}, this.state.urlParams), { email: email }) });
                this.inputs.email = email;
                if (usernameAttributes === 'email') {
                    this.inputs.username = email;
                }
            }
        }
    };
    AuthPiece.prototype.getUsernameFromInput = function () {
        var _a = this.props.usernameAttributes, usernameAttributes = _a === void 0 ? 'username' : _a;
        switch (usernameAttributes) {
            case types_1.UsernameAttributes.EMAIL:
                return this.inputs.email;
            case types_1.UsernameAttributes.PHONE_NUMBER:
                return this.phone_number;
            default:
                return this.inputs.username;
        }
    };
    AuthPiece.prototype.onPhoneNumberChanged = function (phone_number) {
        this.phone_number = phone_number;
    };
    AuthPiece.prototype.renderUsernameField = function (theme, uiFramework, field) {
        var _a = this.props.usernameAttributes, usernameAttributes = _a === void 0 ? [] : _a;
        var urlParams = this.state.urlParams;
        if (usernameAttributes === types_1.UsernameAttributes.EMAIL) {
            if (urlParams && urlParams.email) {
                // controlled input
                return (React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework },
                    !field ?
                        React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                            core_1.I18n.get('Email'),
                            " *")
                        :
                            React.createElement(React.Fragment, null, field.required ?
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                                    core_1.I18n.get(field.label),
                                    " *") :
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework }, core_1.I18n.get(field.label))),
                    React.createElement(Amplify_UI_Components_React_1.Input, { autoFocus: true, placeholder: core_1.I18n.get('Enter your email'), theme: theme, uiFramework: uiFramework, key: "email", name: "email", onChange: this.handleInputChange, "data-test": data_test_attributes_1.auth.genericAttrs.emailInput, value: urlParams.email, disabled: true })));
            }
            else {
                // uncontrolled input
                return (React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework },
                    !field ?
                        React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                            core_1.I18n.get('Email'),
                            " *")
                        :
                            React.createElement(React.Fragment, null, field.required ?
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                                    core_1.I18n.get(field.label),
                                    " *") :
                                React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework }, core_1.I18n.get(field.label))),
                    React.createElement(Amplify_UI_Components_React_1.Input, { autoFocus: true, placeholder: core_1.I18n.get('Enter your email'), theme: theme, uiFramework: uiFramework, key: "email", name: "email", onChange: this.handleInputChange, "data-test": data_test_attributes_1.auth.genericAttrs.emailInput })));
            }
        }
        else if (usernameAttributes === types_1.UsernameAttributes.PHONE_NUMBER) {
            return (React.createElement(PhoneField_1.PhoneField, { theme: theme, onChangeText: this.onPhoneNumberChanged, uiFramework: uiFramework }));
        }
        else {
            return (React.createElement(Amplify_UI_Components_React_1.FormField, { theme: theme, uiFramework: uiFramework },
                !field ?
                    React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                        core_1.I18n.get(this.getUsernameLabel()),
                        " *")
                    :
                        React.createElement(React.Fragment, null, field.required ?
                            React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework },
                                core_1.I18n.get(field.label),
                                " *") :
                            React.createElement(Amplify_UI_Components_React_1.InputLabel, { theme: theme, uiFramework: uiFramework }, core_1.I18n.get(field.label))),
                React.createElement(Amplify_UI_Components_React_1.Input, { autoFocus: true, placeholder: core_1.I18n.get('Enter your username'), theme: theme, uiFramework: uiFramework, key: "username", name: "username", onChange: this.handleInputChange, "data-test": data_test_attributes_1.auth.genericAttrs.usernameInput })));
        }
    };
    AuthPiece.prototype.getUsernameLabel = function () {
        var _a = this.props.usernameAttributes, usernameAttributes = _a === void 0 ? types_1.UsernameAttributes.USERNAME : _a;
        return labelMap[usernameAttributes] || usernameAttributes;
    };
    // extract username from authData
    AuthPiece.prototype.usernameFromAuthData = function () {
        var authData = this.props.authData;
        if (!authData) {
            return '';
        }
        var username = '';
        if (typeof authData === 'object') { // user object
            username = authData.user ? authData.user.username : authData.username;
        }
        else {
            username = authData; // username string
        }
        return username;
    };
    AuthPiece.prototype.errorMessage = function (err) {
        if (typeof err === 'string') {
            return err;
        }
        return err.message ? err.message : JSON.stringify(err);
    };
    AuthPiece.prototype.triggerAuthEvent = function (event) {
        var state = this.props.authState;
        if (this.props.onAuthEvent) {
            this.props.onAuthEvent(state, event);
        }
    };
    AuthPiece.prototype.changeState = function (state, data) {
        if (this.props.onStateChange) {
            this.props.onStateChange(state, data);
        }
        this.triggerAuthEvent({
            type: 'stateChange',
            data: state
        });
    };
    AuthPiece.prototype.error = function (err) {
        this.triggerAuthEvent({
            type: 'error',
            data: this.errorMessage(err)
        });
    };
    AuthPiece.prototype.handleInputChange = function (evt) {
        this.inputs = this.inputs || {};
        var _a = evt.target, name = _a.name, value = _a.value, type = _a.type, checked = _a.checked;
        var check_type = ['checkbox'].includes(type);
        var multi_type = ['multi'].includes(type);
        var select_type = ['select'].includes(type);
        if (multi_type) {
            if (Array.isArray(value)) {
                var selectedItems = "";
                for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                    var item = value_1[_i];
                    selectedItems += item.value + ",";
                }
                if (selectedItems) {
                    // remove last ','
                    selectedItems = selectedItems.slice(0, -1);
                }
                this.inputs[name] = selectedItems;
            }
            else {
                this.inputs[name] = "";
            }
        }
        else if (select_type) {
            this.inputs[name] = value;
        }
        else {
            var _b = this.props.usernameAttributes, usernameAttributes = _b === void 0 ? 'username' : _b;
            this.inputs[name] = check_type ? checked : value;
            if (this.props.authState === 'verifyContact') {
                this.inputs['checkedValue'] = (check_type || type === 'radio') ? value : null;
            }
            else {
                this.inputs['checkedValue'] = check_type ? value : null;
            }
            if (name === 'email' || name === 'username') {
                if (usernameAttributes === 'email') {
                    this.inputs.username = value.toLowerCase().trim();
                    this.inputs.email = value.toLowerCase().trim();
                }
            }
        }
        this.setState({ inputs: this.inputs });
    };
    AuthPiece.prototype.render = function () {
        if (!this._validAuthStates.includes(this.props.authState)) {
            this._isHidden = true;
            this.inputs = {};
            return null;
        }
        if (this._isHidden) {
            this.inputs = {};
            var track = this.props.track;
            if (track)
                track();
        }
        this._isHidden = false;
        return this.showComponent(this.props.theme || Amplify_UI_Theme_1.default);
    };
    AuthPiece.prototype.showComponent = function (theme) {
        throw 'You must implement showComponent(theme) and don\'t forget to set this._validAuthStates.';
    };
    return AuthPiece;
}(React.Component));
exports.default = AuthPiece;
//# sourceMappingURL=AuthPiece.js.map